import React from "react";
import "../components.css";


export default function Column ({alignment = "top", children}: {alignment?: string, children: React.ReactNode}) {
    
    let colStyle = "";

    switch ( alignment ) {
        case "center":
            colStyle = "center";
            break;
        case "bottom":
            colStyle = "flex-end";
            break;
        case "top":
            colStyle = "flex-start";
            break;
        default:
            colStyle = "flex-start";
            break;
    }

    const style = {
        alignItems: colStyle
    }

    return (
        <div className="column" style={style}>
            {children}
        </div>
    )
}
